// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-info-header__time-period-text {
  font-weight: 700;
}
.student-info-header__group-container {
  background-color: white;
  padding: 16px;
  border-radius: 10px;
  width: fit-content;
}
.student-info-header__group-title {
  font-weight: 500;
  color: #0A4064;
}
.student-info-header__student-selector {
  display: flex;
  align-items: center;
}
.student-info-header__student-label {
  font-weight: 500;
  font-size: 20px;
  color: #0A4064;
}
.student-info-header__student-select {
  margin-left: 8px;
}
.student-info-header__main-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.student-info-header__student-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.student-info-header__semester1-button {
  width: 100%;
  margin-bottom: 8px;
  margin-left: -10px;
}
.student-info-header__student-name {
  font-size: 20px;
  font-weight: 600;
}
.student-info-header__student-number {
  opacity: 0.75;
  font-size: 14px;
}
.student-info-header__actions {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  text-align: right;
}
.student-info-header__action-item {
  margin-bottom: 16px;
}
.student-info-header__pdf-container {
  width: 220px;
}
.student-info-header__pdf-note {
  font-size: 0.75rem;
  margin-top: 2px;
  font-style: italic;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/teacher/singleStudentPage/StudentInfoHeader.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAGE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAIE;EACE,gBAAA;EACA,cAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;AAHJ;AAME;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAPJ;AAUE;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;AARJ;AAWE;EACE,eAAA;EACA,gBAAA;AATJ;AAYE;EACE,aAAA;EACA,eAAA;AAVJ;AAaE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AAXJ;AAcE;EACE,mBAAA;AAZJ;AAeE;EACE,YAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAdJ","sourcesContent":[".student-info-header {\n  &__time-period-text {\n    font-weight: 700;\n  }\n\n  &__group-container {\n    background-color: white;\n    padding: 16px;\n    border-radius: 10px;\n    width: fit-content;\n  }\n\n  &__group-title {\n    font-weight: 500;\n    color: #0A4064;\n  }\n\n  &__student-selector {\n    display: flex;\n    align-items: center;\n  }\n\n  &__student-label {\n    font-weight: 500;\n    font-size: 20px;\n    color: #0A4064;\n  }\n\n  &__student-select {\n    margin-left: 8px;\n  }\n\n  &__main-content {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 16px;\n  }\n\n  &__student-info {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n  }\n\n  &__semester1-button {\n    width: 100%;\n    margin-bottom: 8px;\n    margin-left: -10px;\n  }\n\n  &__student-name {\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  &__student-number {\n    opacity: 0.75;\n    font-size: 14px;\n  }\n\n  &__actions {\n    display: flex;\n    flex-direction: column;\n    margin-top: 8px;\n    text-align: right;\n  }\n\n  &__action-item {\n    margin-bottom: 16px;\n  }\n\n  &__pdf-container {\n    width: 220px;\n  }\n\n  &__pdf-note {\n    font-size: 0.75rem;\n    margin-top: 2px;\n    font-style: italic;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
